import type { TransitionMeetingTimeframeSettingResource } from "api/generated";
import type { TimeframeSettings } from "meetings/advisory/types";

export const timeframeSettingsFromDto = (
  dto: TransitionMeetingTimeframeSettingResource | null,
): TimeframeSettings | null => {
  if (!dto) {
    return null;
  }

  return {
    id: dto.id,
    meetingId: dto.meeting_id,
    opensAt: new Date(dto.opens_at),
    closedModifyAt: new Date(dto.closed_modify_at),
    closedAt: new Date(dto.closed_at),
  };
};
